{
  "nl": {
    "courseEnrollments": {
      "headers": {
        "title": "Mijn Cursussen"
      },
      "tabs": {
        "active": "Actief",
        "bookmarked": "Opgeslagen",
        "completed": "Afgerond"
      },
      "empty": {
        "noInProgress": "Je hebt momenteel geen cursussen in uitvoering.",
        "noBookmarked": "Je hebt nog geen cursussen opgeslagen.",
        "noCompleted": "Je hebt nog geen cursussen afgerond.",
        "showAllCourses": "Alle cursussen in de cursuscatalogus tonen"
      }
    }
  }
}
